import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { Injectable } from "@angular/core";
import { Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { UserQuery } from '../user/user.query';
import {GenesystokenService} from '../genesystoken.service';
import { catchError, shareReplay, tap, timeout } from 'rxjs/operators';
@Injectable({ providedIn: 'root' })
export class requestsService {
    baseApi = environment.baseApi;
    private envListCache$: Observable<any> = null;
    
    resion="eu_west_2";
    httpheaders = {
        headers: new HttpHeaders(
            {
                'Content-Type': 'application/json',
                'accept': 'application/json',
                'region':this.resion
            }
        )
    };

    fileHeaders = {
        headers: new HttpHeaders({
        })
    }

    imgHeaders = {
        headers: new HttpHeaders({
            'accept': 'image/*'
        })
    }

    audiohttpOptions = {
        headers: new HttpHeaders(
            {
                'Content-Type': 'application/octet-stream',
                'accept': 'application/octet-stream',
                'region':this.resion
            }
        )
    };

    constructor(
        private userQuery: UserQuery,
        private http: HttpClient,private genesys:GenesystokenService) {

    }

    user() {

    }

    query(url, httpheaders = this.httpheaders) {
        return this.http.get<any>(
            `${this.baseApi}${url}`,
            httpheaders
        );
    }

    post(url, params = null, httpheaders = this.httpheaders) {
        return this.http.post<any>(
            `${this.baseApi}${url}`,
            params,
            httpheaders
        );
    }

    put(url, params = null) {
        return this.http.put<any>(
            `${this.baseApi}${url}`,
            params,
            this.fileHeaders
        );
    }

    delete(url, headers = null) {
        const httpheaders = this.httpheaders;
        return this.http.delete<any>(
            `${this.baseApi}${url}`,
            httpheaders
        );
    }

    // userPlanDetails() {
    //     return this.query('/getCognitoUserGroup');
    // }

    getChannels() {
        return this.query('/channel/list');
    }

    allServiceList() {
        return this.query('/service/list');
    }

    getService(id) {
        return this.query('/service/get?serviceId=' + id);
    }
    getUserAdminList(){
        //return this.query('/adminUser/findAll');
        var userToken = this.userQuery.getToken();
        var headers_object = new HttpHeaders().set("Authorization",  userToken).set("tokenType",this.genesys.tokenType);
        return this.http.get(`${this.baseApi}/adminUser/findAll`,{headers:headers_object})
    }
    OnechangegetUserAdminList(){
        //return this.query('/adminUser/findAll');
        var userToken = this.userQuery.getToken();
        var headers_object = new HttpHeaders().set("Authorization",  userToken).set("tokenType",this.genesys.tokenType);
        return this.http.get(`${this.baseApi}/adminUser/findAll`,{headers:headers_object})
    }
    createEditAdminUser(data){
        var userToken = this.userQuery.getToken();
        var headers_object = new HttpHeaders().set("Authorization",  userToken).set("tokenType",this.genesys.tokenType);
        return this.http.post(`${this.baseApi}/adminUser/saveOrUpdate`,data, {headers:headers_object})
       // return this.post('/adminUser/saveOrUpdate' , data)
    }
    validateAdminCredentials(data){
        var userToken = this.userQuery.getToken();
        var headers_object = new HttpHeaders().set("Authorization",  userToken).set("tokenType",this.genesys.tokenType);
        return this.http.post(`${this.baseApi}/adminUser/validateCredentials`, data, {headers:headers_object, responseType: 'text'})
    }
    getUserAdmin(id){
        var userToken = this.userQuery.getToken();
        var headers_object = new HttpHeaders().set("Authorization",  userToken).set("tokenType",this.genesys.tokenType);
        return this.http.get(`${this.baseApi}/adminUser/findById?id=`+ id, {headers:headers_object})
    }
    OnechangegetEnvirnmtList(){
        var userToken = this.userQuery.getToken();
        var headers_object = new HttpHeaders().set("Authorization",  userToken).set("tokenType",this.genesys.tokenType);
        return this.http.get(`${this.baseApi}/adminUser/organizations`, {headers:headers_object})
    }
    getEnvirnmtList(){
        if (!this.envListCache$) {
            var userToken = this.userQuery.getToken();
            var headers_object = new HttpHeaders().set("Authorization",  userToken).set("tokenType",this.genesys.tokenType);
            this.envListCache$ = this.http.get(`${this.baseApi}/adminUser/organizations`, {headers:headers_object}).pipe(
                shareReplay(1)
            );
        }
        return this.envListCache$;
    }

    clearEnvListCache() {
        this.envListCache$ = null;
    }

    getAllOrganizationsForAdmin() {
        var userToken = this.userQuery.getToken();
        var headers_object = new HttpHeaders().set("Authorization", userToken).set("tokenType", this.genesys.tokenType);
        return this.http.get(`${this.baseApi}/platformAdmin/getAllOrganizations`, {headers: headers_object});
    }

    getAllOrganizationCredentials() {
        var userToken = this.userQuery.getToken();
        var headers_object = new HttpHeaders().set("Authorization", userToken).set("tokenType", this.genesys.tokenType);
        return this.http.get(`${this.baseApi}/platformAdmin/getAllOrganizationCredentials`, {headers: headers_object});
    }

    getAllRegionEnvironmentMappings() {
        var userToken = this.userQuery.getToken();
        var headers_object = new HttpHeaders().set("Authorization", userToken).set("tokenType", this.genesys.tokenType);
        return this.http.get(`${this.baseApi}/platformAdmin/getAllRegionEnvironmentMappings`, {headers: headers_object});
    }

    addRegionEnvironmentMapping(data: any) {
        var userToken = this.userQuery.getToken();
        var headers_object = new HttpHeaders().set("Authorization", userToken).set("tokenType", this.genesys.tokenType);
        return this.http.post(`${this.baseApi}/platformAdmin/addRegionEnvironmentMapping`, data, {headers: headers_object});
    }

    updateRegionEnvironmentMapping(data: any) {
        var userToken = this.userQuery.getToken();
        var headers_object = new HttpHeaders().set("Authorization", userToken).set("tokenType", this.genesys.tokenType);
        return this.http.put(`${this.baseApi}/platformAdmin/updateRegionEnvironmentMapping`, data, {headers: headers_object});
    }
    //added on 14th March 2024
    getURLList(){
        var userToken = this.userQuery.getToken();
        var headers_object = new HttpHeaders().set("Authorization",  userToken).set("tokenType",this.genesys.tokenType);
        return this.http.get(`${this.baseApi}/adminUser/getAllRegions`, {headers:headers_object})
     
    }
    getPacakgeListFiltred(params): Observable<any>{
        var userToken = this.userQuery.getToken();
        var headers_object = new HttpHeaders().set("Authorization",  userToken).set("tokenType",this.genesys.tokenType);
    return this.http.post(`${this.baseApi}/audit/getAuditDataFromDb`,params, {headers:headers_object});
    }
    getMultipleAuditDataFromDb(params): Observable<any>{
        var userToken = this.userQuery.getToken();
        var headers_object = new HttpHeaders().set("Authorization",  userToken).set("tokenType",this.genesys.tokenType);
    return this.http.post(`${this.baseApi}/audit/getMultipleAuditDataFromDb`,params, {headers:headers_object});
    }
   
  getPromotedPackageReport(params): Observable<any>{
    var userToken = this.userQuery.getToken();
    var headers_object = new HttpHeaders().set("Authorization",  userToken).set("tokenType",this.genesys.tokenType);
return this.http.post(`${this.baseApi}/package/getPromotePackageReport`,params, {headers:headers_object});
}
//added on 16/11/2023
AWSMembershipDetails(){
    var userToken = this.userQuery.getToken();
        var headers_object = new HttpHeaders().set("Authorization",  userToken).set("tokenType",this.genesys.tokenType);
    return this.http.get(`${this.baseApi}/getMembershipDetails`,{headers:headers_object})
}
//added on 7thjune2023
getPromoteRollBack(SprintId):Observable<any>{
    var userToken = this.userQuery.getToken();
    var headers_object = new HttpHeaders().set("Authorization",  userToken).set("tokenType",this.genesys.tokenType);
      return this.http.get(`${this.baseApi}/package/rollbackPackagePromote?id=`+SprintId, {headers:headers_object});
  }
    packageList():Observable<any>{
        var userToken = this.userQuery.getToken();
        var headers_object = new HttpHeaders().set("Authorization",  userToken).set("tokenType",this.genesys.tokenType);
        return this.http.get(`${this.baseApi}/package/findAll `, {headers:headers_object});
        
    }
    //commented on 12/10/23
        // promotePackage(envId ,packageId ){
        //         var userToken = this.userQuery.getToken();
        //         var headers_object = new HttpHeaders().set("Authorization",  userToken).set('region',this.resion);
        //     return this.http.post(`${this.baseApi}/package/promote?packageId='+packageId+'&envId='+envId,{}, {headers:headers_object});
        //     }
promotePackage(toOrganizationId: string, packageId: string) {
  const userToken = this.userQuery.getToken();

  const headers_object = new HttpHeaders()
    .set("Authorization", userToken)
    .set("tokenType", this.genesys.tokenType);

  return this.http.post(
    `${this.baseApi}/package/promote?toOrganizationId=${toOrganizationId}&packageId=${packageId}`,
    {},
    {
      headers: headers_object,
      observe: 'response' // 👈 Needed to access headers
    }
  );
}


            AddGitDetails(data):Observable<any>{
                var userToken = this.userQuery.getToken();
                var headers_object = new HttpHeaders().set("Authorization",  userToken).set("tokenType",this.genesys.tokenType);
                return this.http.post(`${this.baseApi}/gitDetails/saveOrUpdate`,data, {headers:headers_object});
            }
            delGit(id){
                var userToken = this.userQuery.getToken();
                var headers_object = new HttpHeaders().set("Authorization",  userToken).set("tokenType",this.genesys.tokenType);
                return this.http.delete(`${this.baseApi}/gitDetails/delete?id=`+id, {headers:headers_object});
            }
            getGitDetail(id){
                var userToken = this.userQuery.getToken();
                var headers_object = new HttpHeaders().set("Authorization",  userToken).set("tokenType",this.genesys.tokenType);
                return this.http.get(`${this.baseApi}/gitDetails/findById?id=`+id, {headers:headers_object});
            }
            AddbackupSchedule(data):Observable<any>{
                var userToken = this.userQuery.getToken();
                var headers_object = new HttpHeaders().set("Authorization",  userToken).set("tokenType",this.genesys.tokenType);
                return this.http.post(`${this.baseApi}/userProfile/addUpdateBackupSchedule`,data, {headers:headers_object});
            }
            getBackupSchedule():Observable<any>{
                var userToken = this.userQuery.getToken();
        var headers_object = new HttpHeaders().set("Authorization",  userToken).set("tokenType",this.genesys.tokenType);
                return this.http.get(`${this.baseApi}/userProfile/listBackupSchedules`, {headers:headers_object});
            }
            getBackupSchedulebyId(id){
                var userToken = this.userQuery.getToken();
                var headers_object = new HttpHeaders().set("Authorization",  userToken).set("tokenType",this.genesys.tokenType);
                return this.http.get(`${this.baseApi}/userProfile/getBackupScheduleDetail?id=`+id, {headers:headers_object});
            }
            deleteschedule(id){
                var userToken = this.userQuery.getToken();
                var headers_object = new HttpHeaders().set("Authorization",  userToken).set("tokenType",this.genesys.tokenType);
                return this.http.delete(`${this.baseApi}/userProfile/deleteBackupSchedule?id=`+ id, {headers:headers_object})
        
            }
            getRepositoryTypeList():Observable<any>{
                var userToken = this.userQuery.getToken();
        var headers_object = new HttpHeaders().set("Authorization",  userToken).set("tokenType",this.genesys.tokenType);
                return this.http.get(`${this.baseApi}/gitDetails/findAll`, {headers:headers_object});
            }
    getMember():Observable<any>{
        var userToken = this.userQuery.getToken();
        var headers_object = new HttpHeaders().set("Authorization",  userToken).set("tokenType",this.genesys.tokenType);
        return this.http.get(`${this.baseApi}/git/getMemberProjects`, {headers:headers_object});   
    }
    getBrancheList(projectId):Observable<any>{
        var userToken = this.userQuery.getToken();
        var headers_object = new HttpHeaders().set("Authorization",  userToken).set("tokenType",this.genesys.tokenType);
        return this.http.get(`${this.baseApi}/git/getBranchListByProjectId?id=`+projectId, {headers:headers_object});
        
    }
    importPackageToRepo(data):Observable<any>{
        var userToken = this.userQuery.getToken();
        var headers_object = new HttpHeaders().set("Authorization",  userToken).set("tokenType",this.genesys.tokenType);
        return this.http.post(`${this.baseApi}/git/importToGitlab`,data, {headers:headers_object});
        }
    exportPackageToRepo(data):Observable<any>{
        var userToken = this.userQuery.getToken();
        var headers_object = new HttpHeaders().set("Authorization",  userToken).set("tokenType",this.genesys.tokenType);
            return this.http.post(`${this.baseApi}/git/exportToGitlab`,data, {headers:headers_object});
            }
    exportPackage(id): Observable<any>{
        var userToken = this.userQuery.getToken();
        var headers_object = new HttpHeaders().set("Authorization",  userToken).set("tokenType",this.genesys.tokenType);
        return this.http.get(`${this.baseApi}/package/getPackageChangesByPackage?id=`+id, {headers:headers_object});
    }
    //added on 11/12/23
    // getFlowName(environmentId,flowtype) {
    //     return this.query(`/getFlows?environmentId=${environmentId}&flowtype=${flowtype}`);
    // }
   
    getFlowName1(environmentId,flowtype): Observable<any>{
        var userToken = this.userQuery.getToken();
        var headers_object = new HttpHeaders().set("Authorization",  userToken).set("tokenType",this.genesys.tokenType);
        return this.http.get(`${this.baseApi}/getFlows?environmentId=`+environmentId+'&flowtype='+flowtype, {headers:headers_object});
    }
    getFlowDependencies(flowId, srcOrgId, objectType, version, destOrgId): Observable<any>{
        var userToken = this.userQuery.getToken();
        var headers_object = new HttpHeaders().set("Authorization",  userToken).set("tokenType",this.genesys.tokenType);
        return this.http.get(`${this.baseApi}/getFlowDependencies?flowId=${encodeURIComponent(flowId)}&srcOrgId=${encodeURIComponent(srcOrgId)}&objectType=${encodeURIComponent(objectType)}&version=${encodeURIComponent(version)}&destOrgId=${encodeURIComponent(destOrgId)}`, {headers:headers_object});
    }
    //added on 13/12/23
    promoteflow(params): Observable<any>{
        var userToken = this.userQuery.getToken();
        var headers_object = new HttpHeaders().set("Authorization",  userToken).set("tokenType",this.genesys.tokenType);
    return this.http.post(`${this.baseApi}/exportYml`,params, {headers:headers_object});
    }
    //added on 21/12/2023
    underpromoteFlow(pmId): Observable<any>{
        var userToken = this.userQuery.getToken();
        var headers_object = new HttpHeaders().set("Authorization",  userToken).set("tokenType",this.genesys.tokenType);
        return this.http.get(`${this.baseApi}/getFlowPromoteStatus?id=`+pmId, {headers:headers_object});
    }
    importPackage(data): Observable<any>{

        var userToken = this.userQuery.getToken();
//this below line commented on 10/04/24
        // var headers_object = new HttpHeaders().set("Authorization",  userToken)
       //this below line applied on 10/04/24
        var headers_object = new HttpHeaders().set("Authorization",  userToken).set("tokenType",this.genesys.tokenType)

        .set('region',this.resion)

        .set('Content-Type', 'application/json')

        .set('accept', 'application/json');

        return this.http.post(`${this.baseApi}/package/updatePackageChanges`,data, {headers:headers_object});

    }
    getPackageDetailsByPackage(id):Observable<any>{
        var userToken = this.userQuery.getToken();
        var headers_object = new HttpHeaders().set("Authorization",  userToken).set("tokenType",this.genesys.tokenType);
        return this.http.get(`${this.baseApi}/package/findById?id=`+id, {headers:headers_object});
    }
    delPackage(id){
        var userToken = this.userQuery.getToken();
        var headers_object = new HttpHeaders().set("Authorization",  userToken).set("tokenType",this.genesys.tokenType);
        if (Array.isArray(id)) {
            let params = new HttpParams();
            id.forEach(v => { params = params.append('ids', v); });
            return this.http.delete(`${this.baseApi}/package/delete`, {headers:headers_object, params:params});
        }
        return this.http.delete(`${this.baseApi}/package/delete?id=`+id, {headers:headers_object});
    }
    savePackage(parms){
        var userToken = this.userQuery.getToken();
        var headers_object = new HttpHeaders().set("Authorization",  userToken).set("tokenType",this.genesys.tokenType);
        return this.http.post(`${this.baseApi}/package/save`, parms, {headers:headers_object});
    }
    deleteUserAdmin(id){
        var userToken = this.userQuery.getToken();
        var headers_object = new HttpHeaders().set("Authorization",  userToken).set("tokenType",this.genesys.tokenType);
        return this.http.delete(`${this.baseApi}/adminUser/delete?id=`+ id, {headers:headers_object})

    }

    createService(params) {
        return this.post('/service/addUpdate', params);
    }

    updateService(params) {
        return this.post('/service/addUpdate', params);
    }

    removeService(id) {
        return this.delete('/service/delete?serviceId=' + id);
    }

    allScriptsList() {
        return this.query('/script/list');
    }

    allScriptsByChannelId(id) {
        return this.query('/script/listScriptByChannel?channelId=' +id);
    }

    allServiceBychannelId(id) {
        return this.query('/service/listServiceByChannel?channelId='+id);
    }

    getScript(id) {
        return this.query('/script/get?scriptId=' + id);
    }
    createScript(params) {
        return this.post('/script/addUpdate', params);
    }

    updateScript(params) {
        return this.post('/script/addUpdate', params);
    }

    removeScript(id) {
        return this.delete('/script/delete?scriptId=' + id);
    }

    pricingPlans() {
        return this.query('/membership/list');
    }

    allSprints() {
        return this.query('/sprint/listSprint');
    }

    allSprintsByType(type) {
        return this.query('/sprint/listSprintByTestType?testType=' + type);
    }

    createSprint(params) {
        return this.post('/sprint/addUpdateSprint', params);
    }

    sprintById(id) {
        return this.query('/sprint/getSprint?sprintId=' + id);
    }
    // http://demo.onecg.cc:8901/api/v2/onecgtest/sprint/getSprintName/%7Bs[rintid%7D
    getsprintById(id,params) {
        return this.post('/sprint/getAutoPilotHistByDate?sprintId=' + id,params);
    }

    runSpring(id) {
        return this.query('/sprint/runSprint?sprintId=' + id);
    }

    stopSprint(sprint, client) {
        return this.query(`/sprint/terminateSprint?sprintId=${sprint}&clientId=${client}`);
    }
    stoploadSprint(sprint, ) {
        return this.query(`/sprint/terminateLoadTest?loadstartsprintId=${sprint}`);
    }

    removeSpring(id) {
        return this.delete('/sprint/deleteSprint?sprintId=' + id);
    }

    sprintTestHistory(id) {
        return this.query('/autopilotMessage/listMessageData?customerId=' + id);
    }

    sprintStatus(id) {
        return this.query('/sprint/getSprintStatus?clientId=' + id);
    }

    agentProgressSummary(id, clientId) {
        return this.query('/sprint/refreshSprintClientResponse?sprintId=' + id + '&clientId=' + clientId);
    }

    sprintTestHistoryList(id,params) {
        return this.post('/sprint/getAutoPilotHist?sprintId=' + id,params);
    }

    sprintAudioURL(id) {
        return this.baseApi + '/autopilotMessage/getAudio?customerId=' + id;
    }

    sprintAudioDownload(id) {
        return this.query('/autopilotMessage/getAudio?customerId=' + id, this.audiohttpOptions);
    }

    createStripeCheckoutSession(plan) {
        return this.post('/paymentcheckout/savePaymentCard?membershipId=' + plan);
    }

    savePaymentMethodForCustomer(sessiondId) {
        return this.post('/paymentcheckout/savePaymentMethodForCustomer?id=' + sessiondId, { id: sessiondId })
    }

    upgradePlan(planId) {
        return this.post('/paymentcheckout/upgardeMembership?membershipId=' + planId, { membershipId: planId });
    }

    getPaymentMethod() {
        return this.post('/paymentcheckout/getPaymentMethodForCustomer');
    }

    cancelMembership() {
        return this.query('/paymentcheckout/cancelMembership');
    }

    membershipHistory() {
        return this.query('/paymentcheckout/membershipHistory');
    }

    // getTestTypeForUser() {
    //     return this.query('/sprint/getTestTypeForGroup');
    // }

    getSuccessCriteria() {
        return this.query('/sprint/getSuccessCriteria');
    }

    getSuccessCriteriaReturnValue(id) {
        return this.query('/sprint/getCriteriaValues?successCriteriaId=' + id);
    }

    invoiceReport(params): Observable<any[]> {
        return this.post('/report/getInvoiceDetails', params);
    }

    highLevelReport(params): Observable<any[]> {
        return this.post('/report/getHighLevelDetails', params);
    }
    loadSprintReport(params): Observable<any> {
        return this.post('/sprint/getHighLevelLoadSprintReport', params);
    }
    loadSprintDeatilsReport(loadSprintclientId) {
        return this.query('/sprint/getLoadSprintDetailReport?loadSprintclientId=' + loadSprintclientId);
    }
    sprintReport(params): Observable<any> {
        return this.post('/report/billing', params);
    }

    uploadProfileImg(params) {
        return this.post('/user/uploadImage', params, this.fileHeaders);
    }

    // getProfileImg() {
    //     if(this.genesys.tokenType=='genesys'){
    //         var userToken = this.userQuery.getToken();

    //         console.log(userToken)
    //          var headers_object = new HttpHeaders().set("Authorization",  userToken).set("tokenType",this.genesys.tokenType);
    //         return this.http.get('https://labapi.quicktest.ai/user/getImage',{headers:headers_object,responseType:'blob'})
    //     }else{
    //         const userToken = this.userQuery.getToken();
    //         console.log(userToken)
    //         var headers_object = new HttpHeaders().set("Authorization",  userToken).set("tokenType",this.genesys.tokenType);
    //         return this.http.get('https://labapi.quicktest.ai/user/getImage',{headers:headers_object,responseType:'blob'})
    //     }
       
    //    // return this.query('/user/getImage', {headers:headers_object});
    // }

    contactus(params): Observable<any> {

        return this.post('/user/contactUs', params);
    }
    getPaymentDetails() {
        return this.query('/paymentcheckout/getCardDetails');
    }
    getupdatePayment() {
        return this.query('/paymentcheckout/updatePayment');
    }
    SaveupdatePayment(paymentId) {
        return this.post('/paymentcheckout/savePaymentMethodForCustomer?id='+paymentId,{id:paymentId});
    }
    LoadsprintStatus(id) {
        return this.query('/sprint/getLoadTestStatus?loadstartsprintId=' + id);
    }
    LoadrunSpring(id) {
        return this.query('/sprint/runLoadSprint?sprintId=' + id);
    }

   LoadsprintTestHistoryList(id) {
        return this.query('/sprint/getLoadSprintData?sprintId=' + id);
    }
    LoadsprintTestHistoryListbyDate(id,params) {
        return this.post('/sprint/getLoadSprintDataByDate?sprintId=' + id,params);
    }

    loadStatussprintById(id) {
        return this.query('/sprint/getLoadTestStatus?loadstartsprintId=' + id);
    }

    loadStatusssprintDetails(id) {
        return this.query('/sprint/getLoadSprintDetailReport?loadSprintclientId='+id);
    }
    loadStatusssprintMessage(id) {
        return this.query('/autopilotMessage/listMessageData?customerId='+id);
    }

    getDashboardSprintData() {
        return this.query('/dashboardSprint/dashboardScheduleSprint');
    }

    getCountryPhoneNo(coundtryCode) {
        return this.query('/icd/listNumbers?countryCode='+coundtryCode);
    }

    addPhoneNumber(params) {
        return this.post('/fromDetails/addFromNumber', params);
    }

    getListNumber() {
        return this.query('/fromDetails/listNumbers');
    }
    getActiveNumber() {
        return this.query('/whatsappSettings/getActiveWhatsAppDetails');
    }

    deletePhonenumber(phoneNumber) {
        const options = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'accept': 'application/json'
            }),
            body: {
                number:phoneNumber
            },
          };

        var url='/fromDetails/releaseNumber';
        return this.http.delete<any>(
            `${this.baseApi}${url}`,options
        );
        // return this.ht
        // return this.delete('/fromDetails/releaseNumber?number=' + phoneNumber);
    }
    getChatSubChannels(channelId) {
        return this.query('/channel/subchannels?channelId=' +channelId);
    }

    cloudchatRefreshSprintExecution(id, clientId) {
        return this.query('/sprint/refreshSprintExecution?sprintId=' + id + '&clientId=' + clientId);
    }
    addWhatsappNumber(params): Observable<any> {
        const userToken = this.userQuery.getToken();
        // console.log(userToken)
        var headers_object = new HttpHeaders().set("Authorization",  userToken).set("tokenType",this.genesys.tokenType);
        return this.http.post('https://labapi.quicktest.ai/whatsappSettings/addWhatsappNumber', params,{headers:headers_object});
    }
    getWhatsAppDetails() {
        return this.query('/whatsappSettings/getWhatsAppDetails');
    }
    
    terminateWhatsappAddNumber(id) {
        return this.query('/whatsappSettings/terminateWhatsappAddNumber?id='+id);
    }
    getQRCode(id) {
        const userToken = this.userQuery.getToken();
        // console.log(userToken)
        var headers_object = new HttpHeaders().set("Authorization",  userToken).set("tokenType",this.genesys.tokenType);

        return this.http.get('https://labapi.quicktest.ai/whatsappSettings/getqrCode?id='+id, {headers:headers_object,responseType:'blob'});
    }
    WhatsApptStatus(id) {
        return this.query('/whatsappSettings/getqrstatus?id=' + id);
    }
    listofservice(){
        var userToken = this.userQuery.getToken();
        var headers_object = new HttpHeaders().set("Authorization",  userToken).set("tokenType",this.genesys.tokenType);
            return this.http.get(`${this.baseApi}/audit/serviceList`,{headers:headers_object})
    }
    //added below 4 apis for user management
    getRoleListByUsername(){
        var userToken = this.userQuery.getToken();
        var headers_object = new HttpHeaders().set("Authorization",  userToken).set("tokenType",this.genesys.tokenType);
            return this.http.get(`${this.baseApi}/userProfile/getRoleListByUsername`,{headers:headers_object})
    }
    getUserRoleList(){
        var userToken = this.userQuery.getToken();
        var headers_object = new HttpHeaders().set("Authorization",  userToken).set("tokenType",this.genesys.tokenType);
            return this.http.get(`${this.baseApi}/userProfile/getUserRoleList`,{headers:headers_object})
}
getPendingInvitation(){
    var userToken = this.userQuery.getToken();
    var headers_object = new HttpHeaders().set("Authorization",  userToken).set("tokenType",this.genesys.tokenType);
        return this.http.get(`${this.baseApi}/userProfile/getPendingInvitesByOrganization`,{headers:headers_object})
}
sendMemberInvite(params): Observable<any> {
    var userToken = this.userQuery.getToken();
    var headers_object = new HttpHeaders().set("Authorization",  userToken).set("tokenType",this.genesys.tokenType);
    return this.http.post(`${this.baseApi}/userProfile/sendMemberInvite`, params,{headers:headers_object});
}
    //this api for entity's component list with gcloudapi baseurl
    serviceName(serviceid){
        var userToken = this.userQuery.getToken();
        var headers_object = new HttpHeaders().set("Authorization",  userToken).set("tokenType",this.genesys.tokenType);
            return this.http.get(`${this.baseApi}/audit/entityList?serviceName=`+serviceid,{headers:headers_object})
    }
    getAction(PeoplePermissions,OAuthClient){
        var userToken = this.userQuery.getToken();
        var headers_object = new HttpHeaders().set("Authorization",  userToken).set("tokenType",this.genesys.tokenType);
            return this.http.get(`${this.baseApi}/audit/actionsList?serviceName=`+PeoplePermissions+'&entityType='+ OAuthClient,{headers:headers_object})
    }
    getAuditData(params): Observable<any> {
        var userToken = this.userQuery.getToken();
        var headers_object = new HttpHeaders().set("Authorization",  userToken).set("tokenType",this.genesys.tokenType);
        return this.http.post(`${this.baseApi}/audit/getAuditData`, params,{headers:headers_object});
    }
   
    //neww added on 18/03
    Onetracklitelistofservice(orgId){
        var userToken = this.userQuery.getToken();
        var headers_object = new HttpHeaders().set("Authorization",  userToken).set("tokenType",this.genesys.tokenType);
            return this.http.get(`${this.baseApi}/audit/serviceList?orgId=`+orgId,{headers:headers_object})
    }
 //new added on 18/03
    OnetrackliteserviceName(orgId,serviceid,moduleName){
        var userToken = this.userQuery.getToken();
        var headers_object = new HttpHeaders().set("Authorization",  userToken).set("tokenType",this.genesys.tokenType);
            return this.http.get(`${this.baseApi}/audit/entityList?orgId=`+orgId+'&serviceName='+serviceid+'&moduleName='+moduleName,{headers:headers_object})
    }
 
 //new added on 18/03
    OnetracklitegetActiongetAction(orgId,PeoplePermissions,OAuthClient){
        var userToken = this.userQuery.getToken();
        var headers_object = new HttpHeaders().set("Authorization",  userToken).set("tokenType",this.genesys.tokenType);
            return this.http.get(`${this.baseApi}/audit/actionsList?orgId=`+orgId+'&serviceName='+PeoplePermissions+'&entityType='+ OAuthClient,{headers:headers_object})
    }

        getUserdetails() {
        var userToken = this.userQuery.getToken();
        var headers_object = new HttpHeaders().set("Authorization",  userToken).set("tokenType",this.genesys.tokenType);
        return this.http.post(`${this.baseApi}/saveUpdateUser`,{headers:headers_object});
    }
    //below code added on 02/-8/24
  OneDesignFetchSourceDate(params) {
  const userToken = this.userQuery.getToken();
  const headers_object = new HttpHeaders()
    .set("Authorization", userToken)
    .set("tokenType", this.genesys.tokenType);

  return this.http.post(
    `${this.baseApi}/copyenvironment/retrieveFromGenesys`,
    params,
    { headers: headers_object }
  ).pipe(
    timeout(120000), // 5 minutes
    catchError(err => {
      if (err.name === 'TimeoutError') {
        return of({
          success: false,
          message: 'Request timed out after 5 minutes.'
        });
      }
      return of({
        success: false,
        message: 'Failed to fetch data. Please try again.'
      });
    })
  );
}
  getSourceDependencies(params) {
    const userToken = this.userQuery.getToken();
    const headers_object = new HttpHeaders()
      .set("Authorization", userToken)
      .set("tokenType", this.genesys.tokenType);
    // TODO: confirm request method and payload with backend API contract.
    return this.http.post(
      `${this.baseApi}/copyenvironment/getSourceDependencies`,
      params,
      { headers: headers_object }
    );
  }

        CopyEnvSavetoDest(params) {
            var userToken = this.userQuery.getToken();
            var headers_object = new HttpHeaders().set("Authorization",  userToken).set("tokenType",this.genesys.tokenType);
            return this.http.post(`${this.baseApi}/copyenvironment/saveToDestination`,params,{headers:headers_object});
            }
            getcopyEnvStatus(uniqueId){
                var userToken = this.userQuery.getToken();
                var headers_object = new HttpHeaders().set("Authorization",  userToken).set("tokenType",this.genesys.tokenType);
                    return this.http.get(`${this.baseApi}/copyenvironment/getCopyStatus?copyDetailsId=`+uniqueId,{headers:headers_object})
            }
            getCopyEnvFailedCount(params) {
                var userToken = this.userQuery.getToken();
                var headers_object = new HttpHeaders().set("Authorization",  userToken).set("tokenType",this.genesys.tokenType);
                return this.http.post(`${this.baseApi}/copyenvironment/getCopyResults`,params,{headers:headers_object});
            }
    rollbackAction(params) {
        var userToken = this.userQuery.getToken();
        var headers_object = new HttpHeaders().set("Authorization",  userToken).set("tokenType",this.genesys.tokenType);
        return this.http.post(`${this.baseApi}/rollback`,params,{headers:headers_object});
    }
    saveRoleListForUser(params) {
        var userToken = this.userQuery.getToken();
        var headers_object = new HttpHeaders().set("Authorization",  userToken).set("tokenType",this.genesys.tokenType);
        return this.http.post(`${this.baseApi}/userProfile/saveRoleListForUser`,params,{headers:headers_object});
    }
    getRoleListForUser(userId){
        var userToken = this.userQuery.getToken();
        var headers_object = new HttpHeaders().set("Authorization",  userToken).set("tokenType",this.genesys.tokenType);
            return this.http.get(`${this.baseApi}/userProfile/getRoleListForUser?userId=`+userId,{headers:headers_object})
    }
    
    AWSUserDetails() {
        var userToken = this.userQuery.getToken();
        var headers_object = new HttpHeaders().set("Authorization",  userToken).set("tokenType",this.genesys.tokenType);
        return this.http.get(`${this.baseApi}/getUserDetails`,{headers:headers_object});
    }
//new userdetail added on 28th june to point onetrack
newUserDetails() {
    var userToken = this.userQuery.getToken();
    // console.log(userToken)
    var headers_object = new HttpHeaders().set("Authorization",  userToken).set("tokenType",this.genesys.tokenType);
    return this.http.get(`${this.baseApi}/getUserDetails`,{headers:headers_object});
}
newlistofservice(orgId){
    var userToken = this.userQuery.getToken();
    var headers_object = new HttpHeaders().set("Authorization",  userToken).set("tokenType",this.genesys.tokenType);
        return this.http.get(`${this.baseApi}/audit/serviceList?orgId=`+orgId,{headers:headers_object})
}
//this api for entity's component list with onetrack baseurl
newserviceName(orgId,serviceid,moduleName){
    var userToken = this.userQuery.getToken();
    var headers_object = new HttpHeaders().set("Authorization",  userToken).set("tokenType",this.genesys.tokenType);
        return this.http.get(`${this.baseApi}/audit/entityList?orgId=`+orgId+'&serviceName='+serviceid+'&moduleName='+moduleName,{headers:headers_object})
}
newgetAction(orgId,PeoplePermissions,OAuthClient){
    var userToken = this.userQuery.getToken();
    var headers_object = new HttpHeaders().set("Authorization",  userToken).set("tokenType",this.genesys.tokenType);
        return this.http.get(`${this.baseApi}/audit/actionsList?orgId=`+orgId+'&serviceName='+PeoplePermissions+'&entityType='+ OAuthClient,{headers:headers_object})
}
getAllActionsList(data){
    var userToken = this.userQuery.getToken();
    var headers_object = new HttpHeaders().set("Authorization",  userToken).set("tokenType",this.genesys.tokenType);
    return this.http.post(`${this.baseApi}/audit/allActionsList`, data, {headers: headers_object});
}
newrollbackAction(params) {
    var userToken = this.userQuery.getToken();
    var headers_object = new HttpHeaders().set("Authorization",  userToken).set("tokenType",this.genesys.tokenType);
    return this.http.post(`${this.baseApi}/rollback`,params,{headers:headers_object});
}
dashboardPieChart(params){
    var userToken = this.userQuery.getToken();
    var headers_object = new HttpHeaders().set("Authorization",  userToken).set("tokenType",this.genesys.tokenType);
        return this.http.post(`${this.baseApi}/reports/topUsersMadeChanges`,params,{headers:headers_object})
}
dashboardModifiedService(params){
    var userToken = this.userQuery.getToken();
    var headers_object = new HttpHeaders().set("Authorization",  userToken).set("tokenType",this.genesys.tokenType);
        return this.http.post(`${this.baseApi}/reports/topModifiedServices`,params,{headers:headers_object})
}
dashboardModifiedEntity(params){
    var userToken = this.userQuery.getToken();
    var headers_object = new HttpHeaders().set("Authorization",  userToken).set("tokenType",this.genesys.tokenType);
        return this.http.post(`${this.baseApi}/reports/topModifiedEntities`,params,{headers:headers_object})
}
dashboardModifiedAction(params){
    var userToken = this.userQuery.getToken();
    var headers_object = new HttpHeaders().set("Authorization",  userToken).set("tokenType",this.genesys.tokenType);
        return this.http.post(`${this.baseApi}/reports/topPerformedActions`,params,{headers:headers_object})
}
DataWisePromotedGraph(params){
    var userToken = this.userQuery.getToken();
    var headers_object = new HttpHeaders().set("Authorization",  userToken).set("tokenType",this.genesys.tokenType);
        return this.http.post(`${this.baseApi}/reports/dateWisePromotedEntitiesCount`,params,{headers:headers_object})
}
   getFlowPromoteReport(params){
                var userToken = this.userQuery.getToken();
                var headers_object = new HttpHeaders().set("Authorization",  userToken).set("tokenType",this.genesys.tokenType);
                return this.http.post(`${this.baseApi}/reports/flowPromoteReport`,params,{headers:headers_object});
            }
            verifyIntegration(flowName,version,srcOrgId){
                  var userToken = this.userQuery.getToken();
        var headers_object = new HttpHeaders().set("Authorization",  userToken).set("tokenType",this.genesys.tokenType);
        return this.http.get(`${this.baseApi}/findIntegrationDetails?flowName=`+flowName+'&version='+version+'&srcOrgId='+srcOrgId, {headers:headers_object});
            }
             generatedToken(){
                  var userToken = this.userQuery.getToken();
        var headers_object = new HttpHeaders().set("Authorization",  userToken).set("tokenType",this.genesys.tokenType);
        return this.http.get(`${this.baseApi}/package/generateApiKeyAndToken`, {headers:headers_object});
            }

            //MFA related API
               updateAuthenticatorAppMFAForOrg(state){
                  var userToken = this.userQuery.getToken();
        var headers_object = new HttpHeaders().set("Authorization",  userToken).set("tokenType",this.genesys.tokenType);
        return this.http.get(`${this.baseApi}/updateAuthenticatorAppMFAForOrg?enableAuthAppMFA=`+state, {headers:headers_object})
        }
        getOrgAuthenticatorAppMFA(){
                 var userToken = this.userQuery.getToken();
        var headers_object = new HttpHeaders().set("Authorization",  userToken).set("tokenType",this.genesys.tokenType);
        return this.http.get(`${this.baseApi}/getOrgAuthenticatorAppMFA`, {headers:headers_object});
        }
         getMFAfromAws(){
            var userToken = this.userQuery.getToken();
        var headers_object = new HttpHeaders().set("Authorization",  userToken).set("tokenType",this.genesys.tokenType);
        return this.http.get(`${this.baseApi}/getMFAfromAws`, {headers:headers_object});
    }
  getbackupList(){
      var userToken = this.userQuery.getToken();
        var headers_object = new HttpHeaders().set("Authorization",  userToken).set("tokenType",this.genesys.tokenType);
        return this.http.get(`${this.baseApi}/backup/findAll`, {headers:headers_object});
  }  
    deletebackup(){
      var userToken = this.userQuery.getToken();
        var headers_object = new HttpHeaders().set("Authorization",  userToken).set("tokenType",this.genesys.tokenType);
        return this.http.delete(`${this.baseApi}/backup/findAll`, {headers:headers_object});
  }     
  getDDataFileList(){
    var userToken = this.userQuery.getToken();
        var headers_object = new HttpHeaders().set("Authorization",  userToken).set("tokenType",this.genesys.tokenType);
        return this.http.get(`${this.baseApi}/dynamicData/file/findAll`, {headers:headers_object});
  }
  uploadDDynamicFile(params){
      var userToken = this.userQuery.getToken();
                var headers_object = new HttpHeaders().set("Authorization",  userToken).set("tokenType",this.genesys.tokenType);
                return this.http.post(`${this.baseApi}/dynamicData/uploadFile`,params,{headers:headers_object});
  }
  deleteDataDrivenFile(fileId){
        var userToken = this.userQuery.getToken();
       var headers_object = new HttpHeaders().set("Authorization",  userToken).set("tokenType",this.genesys.tokenType);
        return this.http.delete(`${this.baseApi}/dynamicData/delete?fileId=`+fileId , {headers:headers_object});
  }
 downloadDDataFile(id){
    var userToken = this.userQuery.getToken();
    var headers_object = new HttpHeaders().set("Authorization",  userToken).set("tokenType",this.genesys.tokenType);
        return this.http.get(`${this.baseApi}/dynamicData/downloadDynamicDataFile?id=`+id,{headers:headers_object,responseType:'blob'})
}
uploadDTemplate(params){
      var userToken = this.userQuery.getToken();
                var headers_object = new HttpHeaders().set("Authorization",  userToken).set("tokenType",this.genesys.tokenType);
                return this.http.post(`${this.baseApi}/dynamicData/uploadTemplate`,params,{headers:headers_object});
  }
//   downloadTemplateFile(params){
//     var userToken = this.userQuery.getToken();
//     var headers_object = new HttpHeaders().set("Authorization",  userToken).set("tokenType",this.genesys.tokenType);
//         return this.http.get(`${this.baseApi}/dynamicData/downloadTemplateFile`,params,{headers:headers_object,responseType:'blob'})
// }
  getTemplateList(){
    var userToken = this.userQuery.getToken();
        var headers_object = new HttpHeaders().set("Authorization",  userToken).set("tokenType",this.genesys.tokenType);
        return this.http.get(`${this.baseApi}/dynamicData/file/template/findAll`, {headers:headers_object});
  }
 downloadTemplateFile(paramsData: any) {
  const userToken = this.userQuery.getToken();

  const headers_object = new HttpHeaders()
    .set('Authorization', userToken)
    .set('tokenType', this.genesys.tokenType);

  let httpParams = new HttpParams();

  // Convert params object to HttpParams
  Object.keys(paramsData).forEach(key => {
    if (paramsData[key] !== null && paramsData[key] !== undefined) {
      httpParams = httpParams.set(key, paramsData[key]);
    }
  });

  return this.http.get(
    `${this.baseApi}/dynamicData/downloadTemplateFile`,
    {
      headers: headers_object,
      params: httpParams,      // ✅ params passed here
      responseType: 'blob'
    }
  );
}
  deleteTemplate(fileId){
        var userToken = this.userQuery.getToken();
       var headers_object = new HttpHeaders().set("Authorization",  userToken).set("tokenType",this.genesys.tokenType);
        return this.http.delete(`${this.baseApi}/dynamicData/file/template/delete?fileId=`+fileId , {headers:headers_object});
  }
  logout(params){
       var userToken = this.userQuery.getToken();
                var headers_object = new HttpHeaders().set("Authorization",  userToken).set("tokenType",this.genesys.tokenType);
                return this.http.post(`${this.baseApi}/cognito/logout`,params,{headers:headers_object});
    }
  oneCgBuildVersion(){
   var userToken = this.userQuery.getToken();
        var headers_object = new HttpHeaders().set("Authorization",  userToken).set("tokenType",this.genesys.tokenType);
        return this.http.get(`${this.baseApi}/platformAdmin/getOneCGBuildVersion`, {headers:headers_object, responseType: 'text'});
  }
  isPlatFormAdmin(){
   var userToken = this.userQuery.getToken();
        var headers_object = new HttpHeaders().set("Authorization",  userToken).set("tokenType",this.genesys.tokenType);
        return this.http.get(`${this.baseApi}/platformAdmin/isPlatFormAdmin`, {headers:headers_object});
  }
  getApplicationProperties(){
    var userToken = this.userQuery.getToken();
    var headers_object = new HttpHeaders().set("Authorization",  userToken).set("tokenType",this.genesys.tokenType);
    return this.http.get(`${this.baseApi}/platformAdmin/getApplicationProperties`, {headers:headers_object, responseType: 'text'});
  }
  SelectAdminAction(params){ var userToken = this.userQuery.getToken();
                var headers_object = new HttpHeaders().set("Authorization",  userToken).set("tokenType",this.genesys.tokenType);
                return this.http.post(`${this.baseApi}/platformAdmin/executeQuery`,params,{headers:headers_object});
}

  getMigrationMappings() {
    var userToken = this.userQuery.getToken();
    var headers_object = new HttpHeaders().set("Authorization", userToken).set("tokenType", this.genesys.tokenType);
    return this.http.get(`${this.baseApi}/migrationMapping/findAll`, { headers: headers_object });
  }

  createMigrationMapping(data) {
    var userToken = this.userQuery.getToken();
    var headers_object = new HttpHeaders().set("Authorization", userToken).set("tokenType", this.genesys.tokenType);
    return this.http.post(`${this.baseApi}/migrationMapping/save`, data, { headers: headers_object });
  }

  deleteMigrationMapping(id) {
    var userToken = this.userQuery.getToken();
    var headers_object = new HttpHeaders().set("Authorization", userToken).set("tokenType", this.genesys.tokenType);
    return this.http.delete(`${this.baseApi}/migrationMapping/remove?id=` + id, { headers: headers_object });
  }

  getMigrationMappingsByOrg(orgId) {
    var userToken = this.userQuery.getToken();
    var headers_object = new HttpHeaders().set("Authorization", userToken).set("tokenType", this.genesys.tokenType);
    return this.http.get(`${this.baseApi}/migrationMapping/findByOrg?orgId=` + orgId, { headers: headers_object });
  }

  getSupportedEntities() {
    var userToken = this.userQuery.getToken();
    var headers_object = new HttpHeaders().set("Authorization", userToken).set("tokenType", this.genesys.tokenType);
    return this.http.get(`${this.baseApi}/entitycompare/supported-entities`, { headers: headers_object });
  }

  compareEntities(data) {
    var userToken = this.userQuery.getToken();
    var headers_object = new HttpHeaders().set("Authorization", userToken).set("tokenType", this.genesys.tokenType);
    return this.http.post(`${this.baseApi}/entitycompare/compare`, data, { headers: headers_object }).pipe(
      timeout(60000)
    );
  }

  syncEntities(data) {
    var userToken = this.userQuery.getToken();
    var headers_object = new HttpHeaders().set("Authorization", userToken).set("tokenType", this.genesys.tokenType);
    return this.http.post(`${this.baseApi}/entitysync/sync`, data, { headers: headers_object }).pipe(
      timeout(120000)
    );
  }

  getInProgressFlows(sourceOrgId, destinationOrgId): Observable<any> {
    var userToken = this.userQuery.getToken();
    var headers_object = new HttpHeaders().set("Authorization", userToken).set("tokenType", this.genesys.tokenType);
    return this.http.get(`${this.baseApi}/getInProgressFlows?sourceOrgId=${sourceOrgId}&destinationOrgId=${destinationOrgId}`, { headers: headers_object });
  }

  deleteInProgressFlows(id): Observable<any> {
    var userToken = this.userQuery.getToken();
    var headers_object = new HttpHeaders().set("Authorization", userToken).set("tokenType", this.genesys.tokenType);
    return this.http.delete(`${this.baseApi}/deleteInProgressFlows?id=${id}`, { headers: headers_object, responseType: 'text' });
  }
}
